export default "__VITE_ASSET__90b8005d__"